import { useEffect, useState } from 'react';

/**
 * Subscribe to a CSS media query. SSR/test-safe: when `window.matchMedia` is
 * unavailable (e.g. jsdom) it returns `defaultValue` (default `true`, i.e. the
 * desktop layout) so non-browser test environments see the full layout.
 */
export function useMediaQuery(query: string, defaultValue = true): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return defaultValue;
    }
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
